// React
import { createContext } from "react"

// Types
import type { DetailType } from "../../ReturnRecord/types"

interface InvoiceType {
  sales_order_id?: number
  trx_code?: string
  total_payment?:number
}

export const DataContext = createContext<{
  datainvoice: InvoiceType 
  detailreturn: DetailType[]
  onAddDetail: (value: DetailType) => void
}>({
  datainvoice: {
    sales_order_id: 0,
    trx_code: '',
    total_payment: 0,
  },
  detailreturn: [],
  onAddDetail(_) {}
})